
namespace Matrix.Workflow {

    @Serenity.Decorators.registerFormatter([Serenity.ISlickFormatter])
    export class StatusCodeRunbookFormatter implements Serenity.ISlickFormatter {
        format(ctx: Slick.FormatterContext) {
            if (!ctx.value)
                return "";

            var color;
            if (ctx.value === "SUCCEEDED")
                color = "green";
            else if (ctx.value.includes("FAIL") || ctx.value.replace(/ /g, "") === "NOTREADY")
                color = "red";
            else
                color = "amber";

            return `<span class="text-${color}"><i class="fa fa-circle"></i> ${Q.htmlEncode(ctx.value)}</span>`;
        }
    }
}